import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filters" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "controls" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Empty = _resolveComponent("Empty")
  const _component_DropdownCheckgroup = _resolveComponent("DropdownCheckgroup")
  const _component_DropdownCalendar = _resolveComponent("DropdownCalendar")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_UploadButton = _resolveComponent("UploadButton")
  const _component_TableHead = _resolveComponent("TableHead")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_Column = _resolveComponent("Column")
  const _component_TagsGroup = _resolveComponent("TagsGroup")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    items: $props.files,
    total: $props.count,
    loading: $props.loading,
    "sort-field": _ctx.sort_field,
    "sort-order": _ctx.sort_order,
    skip: $props.skip,
    "override-skip": "",
    onPage: $options.onPage,
    onSort: $options.onSort
  }, {
    empty: _withCtx(() => [
      _createVNode(_component_Empty, { bg: "assets/bg-pattern-square.png" }, {
        image: _withCtx(() => [
          _createVNode(_component_Icon, {
            width: "4rem",
            height: "4rem",
            icon: "search",
            class: "icon-svg"
          })
        ]),
        title: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("No files were found")
        ])),
        "sub-text": _withCtx(() => [
          ($props.highlight)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Your search “" + _toDisplayString($props.highlight) + "” did not match any files. ", 1 /* TEXT */),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* HOISTED */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            class: "pointer",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.onReset && $options.onReset(...args)))
          }, "Clear filters")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    "header-left": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DropdownCheckgroup, {
          modelValue: _ctx.filter_exts,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filter_exts) = $event)),
          title: "Type",
          items: $props.allExts
        }, null, 8 /* PROPS */, ["modelValue", "items"]),
        _createVNode(_component_DropdownCalendar, {
          modelValue: _ctx.filter_dates,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filter_dates) = $event)),
          title: "Dates"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" TEMPRARLIY disabled, until we support multiple users for one tenant "),
        _createCommentVNode(" Dropdown v-model=\"dd\" :items=\"[]\" :footnote=\"false\" placeholder=\"Uploaded by\"/ "),
        ($options.can_clear)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "clear-filters",
              width: "2rem",
              height: "2rem",
              stroke: "var(--gray-600)",
              onClick: _cache[3] || (_cache[3] = $event => ($options.clearFilters()))
            }, " Clear All "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    "header-right": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SearchInput, {
          ref: "search",
          delay: 1000,
          onSearch: $options.onSearch
        }, null, 8 /* PROPS */, ["onSearch"]),
        _createVNode(_component_UploadButton, {
          ref: "upload_btn",
          type: "icon",
          onUpload: _cache[4] || (_cache[4] = $event => (_ctx.$emit('upload', $event)))
        }, null, 512 /* NEED_PATCH */),
        _withDirectives(_createVNode(_component_Icon, {
          hoverable: "",
          class: "pointer",
          width: "2rem",
          height: "2rem",
          icon: "trash-04",
          stroke: "var(--gray-600)",
          onClick: $options.onDeleteSelected
        }, null, 8 /* PROPS */, ["onClick"]), [
          [_vShow, _ctx.selected.size > 0]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        class: "name-col",
        style: {"width":"100%"},
        sortable: "",
        "sort-field": "name"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "File name",
            sortable: "",
            "sort-order": sortOrder,
            selected: _ctx.selected.size > 0,
            indeterminate: _ctx.selected.size > 0 && !$options.all_selected,
            disabled: $props.files.length === 0,
            checkbox: "",
            onChange: $options.onToggleHead
          }, null, 8 /* PROPS */, ["sort-order", "selected", "indeterminate", "disabled", "onChange"])
        ]),
        body: _withCtx(({data: {id, name, ext, deleting, processing, failed}}) => [
          _createElementVNode("div", {
            class: "file-name ellipsis-cell",
            disabled: deleting
          }, [
            _createVNode(_component_Checkbox, {
              "model-value": _ctx.selected.has(id),
              disabled: deleting || processing,
              size: "large",
              onChange: $event => ($options.onToggleSelected(id))
            }, null, 8 /* PROPS */, ["model-value", "disabled", "onChange"]),
            _createVNode(_component_FileIcon, {
              ext: ext,
              error: failed,
              pulse: processing
            }, null, 8 /* PROPS */, ["ext", "error", "pulse"]),
            _createElementVNode("div", {
              class: _normalizeClass(["name ellipsed", {failed}])
            }, [
              _createVNode(_component_Highlight, {
                text: name,
                highlight: $props.highlight
              }, null, 8 /* PROPS */, ["text", "highlight"])
            ], 2 /* CLASS */)
          ], 8 /* PROPS */, _hoisted_3)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "size",
        class: "content-width-col",
        sortable: "",
        "sort-field": "size"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "Size",
            sortable: "",
            "sort-order": sortOrder
          }, null, 8 /* PROPS */, ["sort-order"])
        ]),
        body: _withCtx(({data: {size, deleting, failed}}) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text", {failed}]),
            style: {"white-space":"nowrap"},
            disabled: deleting
          }, _toDisplayString(_ctx.$utils.format.bytes(size)), 11 /* TEXT, CLASS, PROPS */, _hoisted_4)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "created_at",
        class: "content-width-col",
        sortable: "",
        "sort-field": "created_at"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "Date created",
            sortable: "",
            "sort-order": sortOrder
          }, null, 8 /* PROPS */, ["sort-order"])
        ]),
        body: _withCtx(({data: {created_at, deleting, failed}}) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text", {failed}]),
            disabled: deleting
          }, _toDisplayString(_ctx.$utils.format.date(created_at)), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "tags",
        class: "content-width-col"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "Tags" })
        ]),
        body: _withCtx(({data: {tags, deleting}}) => [
          _createVNode(_component_TagsGroup, {
            highlight: $props.highlight,
            disabled: deleting,
            tags: tags || []
          }, null, 8 /* PROPS */, ["highlight", "disabled", "tags"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, { class: "content-width-col" }, {
        body: _withCtx(({data: {id, deleting, status}}) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "icon-wrap pointer",
              disabled: deleting
            }, [
              _createVNode(_component_Icon, {
                icon: "download-02",
                hoverable: "",
                width: "2rem",
                height: "2rem",
                stroke: "var(--gray-500)",
                onClick: $event => ($options.onDownload(id))
              }, null, 8 /* PROPS */, ["onClick"])
            ], 8 /* PROPS */, _hoisted_7),
            _createVNode(_component_Popconfirm, {
              width: "max-content",
              "confirm-button-text": "Yes",
              "cancel-button-text": "No",
              title: "Are you sure you want to delete this file?",
              onConfirm: $event => ($options.onDelete(id))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "icon-wrap pointer",
                  disabled: deleting || ['processing'].includes(status)
                }, [
                  _createVNode(_component_Icon, {
                    icon: "trash-04",
                    hoverable: "",
                    width: "2rem",
                    height: "2rem",
                    stroke: "var(--gray-500)"
                  })
                ], 8 /* PROPS */, _hoisted_8)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["items", "total", "loading", "sort-field", "sort-order", "skip", "onPage", "onSort"]))
}